import { createReducer } from 'redux-create-reducer'
import type { GroupId } from 'types/group'
import {
  FORM_PLAYLIST_SHARE_RESET,
  FORM_PLAYLIST_SHARE_UPDATE,
  PLAYLIST_SHARE,
  PLAYLIST_SHARE_ERROR,
  PLAYLIST_SHARE_SUCCESS,
  TRACK_SHARE,
  TRACK_SHARE_ERROR,
  TRACK_SHARE_SUCCESS,
} from '@disco/constants/ActionTypes'
export type PlaylistShareForm = {
  territories: GroupId[] | null | undefined
  recipients: Record<string, any>[]
  subject: string
  message: string
  sharing: boolean
}
export type PlaylistShareFormState = Readonly<PlaylistShareForm>
const initialState: PlaylistShareFormState = {
  territories: null,
  recipients: [],
  subject: '',
  message: '',
  sharing: false,
}
export const playlistShareFormReducer = createReducer<
  PlaylistShareFormState,
  any
>(initialState, {
  [FORM_PLAYLIST_SHARE_RESET]() {
    return initialState
  },

  [FORM_PLAYLIST_SHARE_UPDATE](state, action) {
    return { ...state, ...action.fields }
  },

  [PLAYLIST_SHARE](state) {
    return { ...state, sharing: true }
  },

  [PLAYLIST_SHARE_SUCCESS](state) {
    return { ...state, sharing: false }
  },

  [PLAYLIST_SHARE_ERROR](state) {
    return { ...state, sharing: false }
  },
  [TRACK_SHARE](state) {
    return { ...state, sharing: true }
  },
  [TRACK_SHARE_SUCCESS](state) {
    return { ...state, sharing: false }
  },
  [TRACK_SHARE_ERROR](state) {
    return { ...state, sharing: false }
  },
})
